export default (props) => (
    /**
     * Ícone de um filtro, cor parametrizada.
     * Encontrado na tabela de atributos
     */
    <svg 
    width="16" 
    height="15" 
    viewBox="0 0 16 15" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    >
    <path 
    d="M11.6054 2.23198C10.8084 1.6248 9.92457 1.45984 9.62991 1.86249L9.09861 2.59084L11.9843 4.78689L12.5167 4.05874C12.8103 3.6559 12.4031 2.83837 11.6054 2.23198Z" fill="#C3C3C3"
    />
    <path 
    d="M3.23445 13.9482L6.27389 12.8608L3.38744 10.6642L3.23445 13.9482Z" fill="#C3C3C3"
    />
    <path 
    d="M3.90586 9.92016L6.78564 12.0508L12.0046 4.7588L9.11207 2.56685L3.90586 9.92016Z" fill="#C3C3C3"
    />
    <path 
    d="M2.63007 3.48829C2.33113 3.26489 2.27286 2.84004 2.50062 2.54441C2.72371 2.25484 3.13795 2.19803 3.43075 2.41684L14.4118 10.6228C14.7107 10.8462 14.769 11.271 14.5412 11.5666C14.3181 11.8562 13.9039 11.913 13.6111 11.6942L2.63007 3.48829Z" fill="white"
    />
    <path 
    d="M1.49032 3.89418C1.19031 3.67114 1.13139 3.24548 1.35954 2.94934C1.58223 2.6603 1.99549 2.6031 2.28831 2.82079L13.4196 11.0961C13.7196 11.3192 13.7785 11.7448 13.5504 12.041C13.3277 12.33 12.9144 12.3872 12.6216 12.1695L1.49032 3.89418Z" fill="#C3C3C3"
    />
    </svg>
  );

    